import preparedReducer from './reducer';
import { requestNotifications } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'notifications';

export const selectors = state => state[SLICE_NAME];

export const actions = {
  requestNotifications
};
